import { useEffect, useState } from 'react';

import { DEFAULT_LANGUAGE, LANGUAGE_NAMES } from '@cd3p/core/constants/common';
import 'dayjs/locale/en';
import 'dayjs/locale/es';
import 'dayjs/locale/fr';
import i18next from 'i18next';
import { useSelector } from 'react-redux';

import { dayjs } from 'third-party';

import { useStorage } from 'modules/storage';

import { appSelectors } from 'selectors';

export const useUserLanguage = () => {
  const { updateUserSettingInStorage } = useStorage();
  const userLanguage = useSelector(appSelectors.userLanguage);
  const [locale, setLocale] = useState(i18next.language);

  useEffect(() => {
    const supportedLanguage = LANGUAGE_NAMES[userLanguage || '']
      ? userLanguage
      : DEFAULT_LANGUAGE;

    if (supportedLanguage && i18next.language !== supportedLanguage) {
      dayjs.locale(supportedLanguage);
      i18next.changeLanguage(supportedLanguage);
      setLocale(supportedLanguage);
    }
  }, [userLanguage, updateUserSettingInStorage]);

  return locale;
};
